var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DragAndDropHelper from 'mixins/DragAndDropHelper';
import ActivityStage from 'components/activity/ActivityStage.vue';
import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import CorrectIcon from 'components/icons/WhiteCheckmark.vue';
import DynamicContent from '../components/activity/DynamicContent.vue';
import HtmlRenderer from 'components/activity/HtmlRenderer.vue';
import NextActivityButton from 'components/activity/NextActivityButton.vue';
import TextDisplayList from 'components/text-displays/TextDisplayList.vue';
import WrongIcon from 'components/icons/WhiteX.vue';
import ActivityWrapper from '../components/activity/ActivityWrapper.vue';
import mixins from 'vue-typed-mixins';
const DRAG_DISTANCE_MIN = 100;
export default mixins(DragAndDropHelper()).extend({
    name: 'DragAndDropFractions',
    components: {
        ActivityStage,
        BlinkingCursorText,
        CorrectIcon,
        DynamicContent,
        HtmlRenderer,
        NextActivityButton,
        TextDisplayList,
        WrongIcon,
        ActivityWrapper
    },
    computed: {
        hasGuessedAllAnswers() {
            var _a;
            return this.correctGuesses.length === ((_a = this.currentRound.dropZones) === null || _a === void 0 ? void 0 : _a.length);
        }
    },
    mounted() {
        window.addEventListener('resize', this.recalibrateAnswersOnResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.recalibrateAnswersOnResize);
    },
    methods: {
        // start activity helper methods
        getKeyboardConfig() {
            return this.getKeyboardConfigHelper();
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loadActivityHelper();
            });
        },
        loadAudios(activityAudios) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.loadAudiosHelper(activityAudios);
            });
        },
        startActivity() {
            this.setRoundHelper();
            this.$nextTick(() => {
                this.clearDropItemContainerLabels();
            });
            this.$nextTick(() => {
                this.setActivityContainerHeight();
            });
        },
        // end activity helper methods
        // start activity specific methods
        findClosestDropArea(dragItemCoordinates) {
            const allDroppableAreas = this.getAllDroppableAreas();
            let closestDropZone;
            let distance;
            const { x: dragX, y: dragY } = dragItemCoordinates;
            allDroppableAreas.find((droppableArea, index) => {
                const { x: dropX, y: dropY } = droppableArea.position;
                const xDiff = Math.abs(dragX - dropX);
                const yDiff = Math.abs(dragY - dropY);
                const totalDiff = xDiff + yDiff;
                if (!index)
                    distance = totalDiff;
                if (totalDiff <= distance && totalDiff < DRAG_DISTANCE_MIN)
                    closestDropZone = droppableArea;
            });
            return closestDropZone;
        },
        getDragContentBackground(item) {
            if (this.correctGuesses.some(guess => guess.draggableItem === item))
                return 'white';
            return this.defaultColor;
        },
        getDropZonePosition(closestDropZone, draggableId) {
            const originalDraggablePos = document
                .getElementById(`startingPoint-${draggableId}`)
                .getBoundingClientRect();
            const { position: closestDropZonePos } = closestDropZone;
            const xPos = closestDropZonePos.x - originalDraggablePos.x;
            const yPos = closestDropZonePos.y -
                originalDraggablePos.y -
                (originalDraggablePos.height - closestDropZonePos.height) / 2;
            return { xPos: xPos + 2, yPos: yPos };
        },
        getDraggableItemCorrectlyGuessed(draggableItem) {
            return this.correctGuesses.some(guess => guess.draggableItem.id === draggableItem.id);
        },
        getIsCorrect(guessedAnswer) {
            return guessedAnswer.droppableItem.correctItemIds.includes(guessedAnswer.draggableItem.id);
        },
        handleDrop(context, dropZone = null) {
            const { target } = context;
            const draggableId = target.id.split('-')[1];
            const draggableItem = this.getAssociatedDraggableItem(draggableId);
            if (!draggableItem)
                return;
            this.removeFromGuessed(draggableItem);
            const dragItemCoordinates = target.getBoundingClientRect();
            let closestDropZone = this.findClosestDropArea(dragItemCoordinates);
            if (dropZone) {
                closestDropZone = {
                    id: dropZone.id,
                    position: dropZone.getBoundingClientRect()
                };
            }
            if (closestDropZone) {
                const closestDropZoneId = JSON.parse(closestDropZone.id.split('-')[1]);
                const alreadyGuessed = [...this.guessed, ...this.correctGuesses].some(item => item.droppableItem.id === closestDropZoneId);
                if (alreadyGuessed) {
                    this.resetDraggable(target);
                    return;
                }
                this.handleMoveToDropZone(target, closestDropZone, draggableItem, draggableId);
                return;
            }
            this.resetDraggable(target);
            this.removeFromGuessed(draggableItem);
        },
        handleMoveToDropZone(target, closestDropZone, draggableItem, draggableId) {
            const { id: dropZoneElId } = closestDropZone;
            const dropAreaId = dropZoneElId.split('-')[1];
            const droppableItem = this.getAssociatedDroppableItem(dropAreaId);
            this.guessed = [...this.guessed, { draggableItem, droppableItem }];
            const { xPos, yPos } = this.getDropZonePosition(closestDropZone, draggableId);
            this.moveDraggableToDropZone(target, xPos, yPos);
            this.selectedElement = null;
            return;
        },
        isElementSelected(item) {
            if (this.selectedElement) {
                return this.selectedElement.id === `draggable-${item.id}`;
            }
        },
        isGuessed(draggableItem) {
            if (!draggableItem)
                return false;
            return [...this.guessed, ...this.correctGuesses].some(item => item.draggableItem.id === draggableItem.id);
        },
        isGuessedCorrectly(droppableItem) {
            if (!droppableItem)
                return false;
            return this.correctGuesses.some(item => item.droppableItem.id === droppableItem.id);
        },
        isGuessedIncorrectly(droppableItem) {
            if (!droppableItem)
                return false;
            const isInWrongGuess = this.wrongGuesses.some(item => item.droppableItem.id === droppableItem.id);
            const isGuessed = this.guessed.some(item => item.droppableItem.id === droppableItem.id);
            const isEmpty = !isGuessed && !this.isGuessedCorrectly(droppableItem) && this.isSubmitted;
            return isInWrongGuess || isEmpty;
        },
        clearDropItemContainerLabels() {
            const dropItemContainerEls = document.getElementsByClassName('dropItemContainer') || [];
            Array.from(dropItemContainerEls).forEach(node => {
                const comparisonsArr = node.innerText.split('\n');
                node.setAttribute('aria-label', comparisonsArr.join(` ? `));
            });
        },
        comparisonLabelText(label) {
            const labelTextMap = {
                '=': 'Equals sign',
                '>': 'Greater than sign',
                '<': 'Less than sign',
                '>=': 'Greater than or equals to sign',
                '<=': 'Less than or equal to sign'
            };
            return labelTextMap[label || ''] || '';
        },
        setDropItemContainerLabel(droppableItemId, label) {
            const droppableItem = document.getElementById(`dropArea-${droppableItemId}`);
            if (droppableItem) {
                const dropItemContainerEls = document.getElementsByClassName('dropItemContainer') || [];
                Array.from(dropItemContainerEls).forEach(node => {
                    if (node.contains(droppableItem)) {
                        const comparisonsArr = node.innerText.split('\n');
                        node.setAttribute('aria-label', comparisonsArr.join(` ${label} `));
                    }
                });
            }
        },
        // end activity specific methods
        // start accessibility methods
        recalibrateAnswersOnResize() {
            if (!this.guessed.length)
                return;
            this.guessed.forEach(({ draggableItem, droppableItem }) => {
                var _a;
                const closestDropZone = (_a = this.getAllDroppableAreas()) === null || _a === void 0 ? void 0 : _a.find(({ id }) => id === `dropArea-${droppableItem.id}`);
                const target = document.getElementById(`draggable-${draggableItem.id}`);
                const { xPos, yPos } = this.getDropZonePosition(closestDropZone, draggableItem.id);
                this.moveDraggableToDropZone(target, xPos, yPos);
            });
        }
        // end accessibility methods
    },
    watch: {
        guessed(newVal) {
            this.clearDropItemContainerLabels();
            if (newVal.length) {
                newVal.forEach(guess => {
                    const { draggableItem: { label }, droppableItem: { id } } = guess;
                    this.setDropItemContainerLabel(id, label);
                });
            }
        }
    }
});
